import { render, staticRenderFns } from "./PayMode.vue?vue&type=template&id=283e10b9&scoped=true&"
import script from "./PayMode.vue?vue&type=script&lang=js&"
export * from "./PayMode.vue?vue&type=script&lang=js&"
import style0 from "./PayMode.vue?vue&type=style&index=0&id=283e10b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e10b9",
  null
  
)

export default component.exports